var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var ChevronRightBold = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 2.16195L11.3878 10.033L3.75789 17.8361L5.88969 20L15.75 10.033L5.8818 0H5.87786L3.75 2.16195Z", fill: "currentColor" }))); });
//# sourceMappingURL=ChevronRightBold.js.map